// extracted by mini-css-extract-plugin
module.exports = {"widget":"Widget_widget__3f_tK"};